"use client";
import SectionPage from "@/components/common/section-page";

import { useNavigate, useParams } from "react-router-dom";
import FooterSiteOfficiel from "@/components/site-officiel/footer-site-officiel";
import FlippingBookPDF from "@/components/common/flipping-book-pdf";

export default function Home() {
  const navigate = useNavigate();
  const { filePath }: any = useParams();

  return (
      <main>
          <div className={"flex flex-col gap-6 pb-6 mt-8"}>

          {/* Nature & Biodiversité */}
          <SectionPage sectionType="2xl" className={"bg-gray-200 pb-6"}>
            <FlippingBookPDF
                pdfUrl={`/pdfs/${filePath}`}
                downloadFileName={filePath as string}
            />

          </SectionPage>

        </div>
        <FooterSiteOfficiel />
      </main>
  );
}
